import Vue from 'vue'

Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  let formatter = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR'
  })
  return formatter.format(value)
})
